// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"Cards_cardsContainer__1Oz0e","cardCustom":"Cards_cardCustom__3YbqX"};